import React from "react";
import { Box, useTheme } from "@mui/material";
import CustomTypography from "../../../../../../views/components/common/form/CustomTypography";
import TableState from "../../../../../../views/components/common/table-states/TableState";

interface SectionTaskStatusProps {
  completed: boolean;
}

const SectionTaskStatus: React.FC<SectionTaskStatusProps> = ({ completed }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.75,
        ml: 1.5,
      }}
    >
      <TableState state={completed} height="16px" width="16px" />
      <CustomTypography
        variant="heading8"
        color={theme.palette.customColors.greyTextColor}
      >
        {completed ? "Completed" : "Pending"}
      </CustomTypography>
    </Box>
  );
};

export default SectionTaskStatus;
